import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CpfCnpjValidatorDirective } from './directives/cpf-validator.directive';
import { CnpjMaskPipe } from './pipes/cnpj-mask.pipe';
import { CpfMaskPipe } from './pipes/cpf-mask.pipe';
import { SuggestionSearchInputComponent } from './components/suggestion-search-input/suggestion-search-input.component';
import { EllipsisLoadingComponent } from './components/ellipsis-loading/ellipsis-loading.component';
import { ThousandsMaskPipe } from './pipes/thousands-mask.pipe';
import { SearchInputOptionTemplateDirective } from './components/search-input/search-input-option-template.directive';
import { IconComponent } from '../components/icon/icon.component';
import { WalletSelectComponent } from './components/wallet-select/wallet-select.component';
import { UppercaseDirective } from './directives/uppercase.directive';

@NgModule({
  declarations: [CpfCnpjValidatorDirective, SearchInputOptionTemplateDirective],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    SuggestionSearchInputComponent,
    EllipsisLoadingComponent,
    WalletSelectComponent,
    MatProgressSpinnerModule,
    NgxMaskDirective,
    IconComponent,
    NgxMaskPipe,
    CpfMaskPipe,
    CnpjMaskPipe,
    ThousandsMaskPipe,
    UppercaseDirective,
  ],
  providers: [provideNgxMask()],
  exports: [
    SuggestionSearchInputComponent,
    MatProgressSpinnerModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CpfCnpjValidatorDirective,
    UppercaseDirective,
    CnpjMaskPipe,
    CpfMaskPipe,
    IconComponent,
    ThousandsMaskPipe,
    EllipsisLoadingComponent,
    SearchInputOptionTemplateDirective,
    WalletSelectComponent,
  ],
})
export class SharedModule {}
